import { render, staticRenderFns } from "./Receiptquery.vue?vue&type=template&id=2404384a&scoped=true&"
import script from "./Receiptquery.vue?vue&type=script&lang=js&"
export * from "./Receiptquery.vue?vue&type=script&lang=js&"
import style0 from "./Receiptquery.vue?vue&type=style&index=0&id=2404384a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2404384a",
  null
  
)

export default component.exports